import DashboardLayout from '../layout/DashboardLayout.vue'
// GeneralViews
import NotFound from '../pages/NotFoundPage.vue'
var numAct = ''
// Admin pages
import Home from 'src/pages/Home.vue'
import UserProfile from 'src/pages/UserProfile.vue'
import Suivi_Actions from 'src/pages/Suivi_Actions.vue'
import Typography from 'src/pages/Typography.vue'
import Suivi_Clients from 'src/pages/Suivi_Clients.vue'
import Maps from 'src/pages/Maps.vue'
import Notifications from 'src/pages/Notifications.vue'
import Upgrade from 'src/pages/Upgrade.vue'
import Planning from 'src/pages/Planning.vue'
import Logout from 'src/pages/Logout.vue'
import LoginLayout from 'src/layout/LoginLayout.vue'
import LoginHome from 'src/pages/LoginHome.vue'
import Action from 'src/pages/Action.vue'
import Liste_Taches from 'src/pages/Liste_Taches.vue'
import Filtrer from 'src/pages/Filtrer.vue'
import Mailjet from 'src/pages/Mailjet.vue'
import Ocr from 'src/pages/Ocr.vue'
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import store from '../store/index.js'
const routes = [
  { path: '/',
    redirect: '/admin/home'},
  {
    path: '/login',
    component: LoginLayout,
    redirect: '/login/home',
    children: [
      {
        path: 'home',
        name: 'Home',
        component: LoginHome
      },
      {
        path: 'logout',
        name: 'Logout',
        component: Logout,
      }
    ]
  },
  {
    path: '/admin',
    component: DashboardLayout,
    redirect: '/admin/home',
    children: [
      {
        path: 'home',
        name: 'Home',
        component: Home
      },
      {
        path: 'action',
        name: 'Action',    
        component: Action
      },
        { 
        path: '/redirectMaps',
        name: 'RedirectMaps',
        beforeEnter(to, from, next) {
          console.log(from)
          console.log(to)
          console.log(next)
            // Put the full page URL including the protocol http(s) below
            window.location.replace("https://example.com")
        }
      },
      {
        path: 'logout',
        name: 'Logout',
        component: Logout,
      },
      {
        path: 'user',
        name: 'User',
        component: UserProfile
      },
      {
        path: 'suivi_actions',
        name: 'Suivi Actions',
        component: Suivi_Actions,
       },
     
    
      
      {
        path: 'Liste_Taches',
        name: 'Liste Tâches',
        component: Liste_Taches
       },
      {
        path: 'typography',
        name: 'Typography',
        component: Typography
      },
      {
        path: 'Planning',
        name: 'Planning',
        component: Planning
      },
      {
        path: 'suivi_clients',
        name: 'Suivi Clients',
        component: Suivi_Clients
      },
      {
        path: 'maps',
        name: 'Maps',
        component: Maps
      },
      {
        path: 'Ocr',
        name: 'Ocr',
        component: Ocr
      },
      {
        path: 'Mailjet',
        name: 'Mailjet',
        component: Mailjet
      },
      {
        path: 'notifications',
        name: 'Notifications',
        component: Notifications
      },
      {
        path: 'upgrade',
        name: 'Upgrade to PRO',
        component: Upgrade
      }
    ],
  // pour la connection
        beforeEnter(to, from, next) {
            console.log(to)
          if (store.getters.status == true  ) {
            next();
          }
          else if (to.path == '/login/home' && store.getters.status == false) {
            next();
          } 
          else if (to.path != '/login/home' && store.getters.status == false) {
            next('/login/home');
          }
          return true
        }

  },
  { path: '*', component: NotFound }
]

/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/


export default routes
